/** What `fetchSettingsSaga` reports on `loadError` -- same reasoning as ProcedureIndex's own generic
 * load error: the failure payload's `.message` is either the API's literal error text or an
 * AxiosError's, neither fit for an admin screen. */
export const SETTINGS_LOAD_ERROR = "Something went wrong loading settings. Please try again.";

/** The one toast after a save -- errorHandlerMiddleware (src/store/store.tsx) auto-toasts any
 * `*_SUCCESS` payload carrying a `.message`. A save can be several PUTs (one per dirty key); this is
 * dispatched ONCE, after every one of them has resolved, never per key. */
export const SETTINGS_SAVED_MESSAGE = "Settings saved. It can take up to a minute to apply everywhere.";

/** Shown under a setting when the api's own `requiresEvalBaseline` flag is true (SettingField reads
 * the flag directly -- this screen no longer matches against a fixed key list). */
export const EVAL_BASELINE_NOTE =
  "Changing this requires a new eval baseline before the eval gate compares runs again.";
